import Modal from "src/pages/Modals/ModalBase";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "@phosphor-icons/react";
import { deleteThread, setShowChatActionModal } from "src/store/slices/threadsSlice";
import { toast } from "react-toastify";
import { trackAnalytics } from "src/pages/helpers";
import {
  BUTTON_ROLES,
  BUTTON_TYPES,
  EVENT_NAMES,
  EVENT_PARAMETERS,
  getPageName,
  MODAL_NAMES,
} from "src/utils/EventConstants";

const DeleteThreadModal = (props) => {
  const { open, setActionOnThread, threadInfo } = props;

  const dispatch = useDispatch();

  const [text, setText] = useState("");
  const thread = threadInfo.thread;
  const duration = threadInfo.duration;
  const deleteThreadStatus = useSelector((state) => state.threads.deletedThread);
  const userMetadata = useSelector((state) => state.onboarding.userMetadata);
  const threadData = useSelector((state) => state.messageSlice.threadData);
  const legalReviewRequested = thread?.legal_review_requested;
  const legalReviewSubmitted = thread?.legal_review_submitted;

  useEffect(() => {
    if (deleteThreadStatus?.status === "success" || deleteThreadStatus?.status === "failed") {
      setActionOnThread("");
    }
    switch (deleteThreadStatus?.status) {
      case "success":
        setText(`Deleted ${threadInfo?.title}`);
        // dispatch(addToast({ type: "success", message: `Deleted ${threadInfo?.thread?.title}` }))
        if (threadInfo?.thread?.title) {
          toast.success(`Deleted ${threadInfo?.thread?.title}`);
        }
        break;
      case "failed":
        setText(`Failed to delete ${threadInfo?.thread?.title}. Retry again`);
        break;
      case "loading":
        setText(`Deleting ${threadInfo?.thread?.title}`);
        break;
      default:
        setText(`This will delete ${threadInfo?.thread?.title}`);
    }
  }, [deleteThreadStatus, threadInfo]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (deleteThreadStatus?.status === "success") {
      dispatch(setShowChatActionModal(false));
    }
  }, [deleteThreadStatus]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (open) {
      // Event 46:
      trackAnalytics(
        EVENT_NAMES.VIEWED_MODAL,
        {
          [EVENT_PARAMETERS.PAGE_NAME]: getPageName(),
          [EVENT_PARAMETERS.THREAD_ID]: threadData?.id,
          [EVENT_PARAMETERS.CURRENT_PLAN_TIER]: userMetadata?.subscription_type || "anonymous",
          [EVENT_PARAMETERS.USER_ID]: userMetadata?.id,
          [EVENT_PARAMETERS.MODAL_NAME]: MODAL_NAMES.DELETE_THREAD_MODAL,
        },
        userMetadata,
      );
    }
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal
      isOpen={open}
      onClose={() => setActionOnThread("")}
      closeBtnClassName="right-3 top-3"
      bodyStyle={{ paddingBottom: "0px", borderRadius: "16px", paddingTop: "0px" }}
    >
      <div data-testid="delete-thread-modal" className="w-[100vw] md:w-[600px] h-full flex flex-col items-start px-[30px] py-[40px] gap-[24px]">
        <span data-testid="delete-modal-title" className="text-black text-[30px] font-[800] leading-[1]">Delete chat?</span>
        {legalReviewRequested && !legalReviewSubmitted ? (
          <span className="text-black text-[16px] font-[500] leading-[1]">
            This thread cannot be deleted as it has a legal review pending.
          </span>
        ) : (
          <span className="text-black text-[16px] font-[500] leading-[1]">{text}</span>
        )}

        {legalReviewRequested && !legalReviewSubmitted ? (
          ""
        ) : (
          <div className="flex items-center justify-start w-full gap-4 h-full ">
            <button
              className="btn-base btn-secondary flex justify-center w-full md:w-auto  text-[14px] md:text-[16px] min-w-[120px]"
              onClick={() => {
                // Event 47:
                trackAnalytics(
                  EVENT_NAMES.CLICKED_BUTTON,
                  {
                    [EVENT_PARAMETERS.PAGE_NAME]: getPageName(),
                    [EVENT_PARAMETERS.BUTTON_TYPE]: BUTTON_TYPES.BUTTON_WITH_TEXT,
                    [EVENT_PARAMETERS.BUTTON_TEXT]: "Delete",
                    [EVENT_PARAMETERS.CURRENT_PLAN_TIER]: userMetadata?.subscription_type || "anonymous",
                    [EVENT_PARAMETERS.BUTTON_ROLE]: BUTTON_ROLES.NAVIGATION_NEXT,
                    [EVENT_PARAMETERS.USER_ID]: userMetadata?.id,
                    [EVENT_PARAMETERS.MODAL_NAME]: MODAL_NAMES.DELETE_THREAD_MODAL,
                  },
                  userMetadata,
                );
                if (deleteThreadStatus?.status === "loading") {
                  return;
                }
                dispatch(deleteThread({ id: thread?.id, duration: duration }));
              }}
              disabled={deleteThreadStatus?.status === "loading"}
              id="delete-chat-button"
              data-testid="delete-thread-confirm-btn"
            >
              {deleteThreadStatus?.status === "loading" ? <Spinner size={16} className="animate-spin" /> : "Delete"}
            </button>
            <button
              className="btn-base btn-tertiary w-full md:w-auto text-[14px] md:text-[16px] min-w-[120px]"
              onClick={() => {
                // Event 48:
                trackAnalytics(
                  EVENT_NAMES.CLICKED_BUTTON,
                  {
                    [EVENT_PARAMETERS.PAGE_NAME]: getPageName(),
                    [EVENT_PARAMETERS.THREAD_ID]: threadData?.id,
                    [EVENT_PARAMETERS.BUTTON_TYPE]: BUTTON_TYPES.BUTTON_WITH_TEXT,
                    [EVENT_PARAMETERS.BUTTON_TEXT]: "Cancel",
                    [EVENT_PARAMETERS.CURRENT_PLAN_TIER]: userMetadata?.subscription_type || "anonymous",
                    [EVENT_PARAMETERS.BUTTON_ROLE]: BUTTON_ROLES.NAVIGATION_CANCEL,
                    [EVENT_PARAMETERS.USER_ID]: userMetadata?.id,
                    [EVENT_PARAMETERS.MODAL_NAME]: MODAL_NAMES.DELETE_THREAD_MODAL,
                  },
                  userMetadata,
                );
                setActionOnThread("");
              }}
              disabled={deleteThreadStatus?.status === "loading"}
              id="cancel-delete-chat-button"
              data-testid="delete-thread-cancel-btn"
            >
              Cancel
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default DeleteThreadModal;
